const pdfCache: { [documentId: string]: ArrayBuffer } = {};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default pdfCache;
